// Orbit: a solid cyan prim wrapped by a single inclined ring.
// Keep the geometry in sync with public/favicon.svg.
let ids = 0;

/** Scalable Orbit mark with unique gradient IDs for repeated instances. */
export function logoMark(size = 32): SVGSVGElement {
  const n = ++ids;
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("viewBox", "0 0 48 48");
  svg.setAttribute("width", String(size));
  svg.setAttribute("height", String(size));
  svg.setAttribute("class", "logo");
  svg.setAttribute("aria-hidden", "true");
  svg.innerHTML = `<defs>
  <linearGradient id="pv-top" x2="1" y2="1"><stop stop-color="#65eafa"/><stop offset="1" stop-color="#1dc7ed"/></linearGradient>
  <linearGradient id="pv-left" x2="0" y2="1"><stop stop-color="#12c9ef"/><stop offset="1" stop-color="#0099d8"/></linearGradient>
  <linearGradient id="pv-right" x2="1" y2="1"><stop stop-color="#078dca"/><stop offset="1" stop-color="#00558f"/></linearGradient>
  <linearGradient id="pv-ring" x2="1" y2="0"><stop stop-color="#24c9ef"/><stop offset="0.6" stop-color="#61e9fa"/><stop offset="1" stop-color="#91f3fb"/></linearGradient>
</defs>
<path d="M 2 24 A 22 7.5 0 0 1 46 24" transform="rotate(-30 24 24)" fill="none" stroke="url(#pv-ring)" stroke-width="2.3"/>
<path d="M 11 16.5 L 24 24 L 24 41 L 11 33.5 Z" fill="url(#pv-left)"/>
<path d="M 24 24 L 37 16.5 L 37 33.5 L 24 41 Z" fill="url(#pv-right)"/>
<path d="M 24 9 L 37 16.5 L 24 24 L 11 16.5 Z" fill="url(#pv-top)"/>
<path d="M 2 24 A 22 7.5 0 0 0 46 24" transform="rotate(-30 24 24)" fill="none" stroke="url(#pv-ring)" stroke-width="2.3"/>`.replaceAll("pv-", `pv-${n}-`);
  return svg;
}

/** The mark and the name together, as the login and loading screens show it. */
export function wordmark(size = 34): HTMLElement {
  const box = document.createElement("div");
  box.className = "wordmark";
  box.append(logoMark(size));
  const name = document.createElement("span");
  name.className = "wordmark-name";
  const verse = document.createElement("span");
  verse.className = "wordmark-verse";
  verse.textContent = "verse";
  name.append("Prim", verse);
  box.append(name);
  return box;
}
